import AIInsights from '@/components/organisms/AIInsights'

const AICoach = () => {
  return <AIInsights />
}

export default AICoach